<template>
  <van-overlay :show="isShow">
    <div class="shareInfo">
      <div class="shareContent">
        <div class="img">
          <img :src="line" alt="" class="lineImg">
        </div>
        <div class="steps">
          <div class="step">
            <div class="flag">1</div>
            <div class="content">点击右上角的按钮</div>
          </div>
          <div class="step">
            <div class="flag">2</div>
            <div class="content">选择发送给朋友</div>
          </div>
          <div class="step">
            <div class="flag">3</div>
            <div class="content">好友通过您的分享参与调查，审核通过后，您将获得丰厚红包奖励</div>
          </div>
        </div>
        <div class="know">
          <div @click="isShow = false" class="knowButton">知道啦</div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  data() {
    return {
      line: require('../../assets/images/question/line.png')
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('closeDialog', val)
      }
    }
  }
}
</script>

<style lang="stylus">
.shareInfo {
  display: flex;
  justify-content: center;
  height: 100%;
  padding-top: 280px;
  .shareContent {
    width: 100%;
    padding: 0 67px 0 54px;
    .img {
      text-align: right;
      .lineImg {
        width: 76px;
        height: 101px;
      }
    }
    .steps{
      margin-top: 28px;
      .step {
        margin-bottom: 35px;
        display: flex;
        align-items: center;
        color: #fff
        .flag {
          width: 40px;
          height: 40px;
          background: #368BFF;
          border-radius: 50%;
          text-align: center;
          line-height: 40px;
          font-size: 28px;
        }
        .content {
          margin-left: 29px;
          font-size: 34px;
          font-weight: bold;
          flex: 1 1;
        }
      }
    }
    .know {
      margin-top: 107px;
      text-align: center;
      display: flex;
      justify-content: center;
      .knowButton {
        width: 300px;
        height: 68px;
        line-height: 68px;
        background: #368BFF;
        border-radius: 34px;
        font-size: 28px;
        text-align: center;
        color: #fff;
      }
    }
  }
}
</style>